/**
 * Created by andrey on 20.08.2020.
 */

const Restore = cc.Node.extend({ 
    ctor: function (parentWindow) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.parentWindow = parentWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("RestorePurchases"), cleverapps.styles.FONTS.TERMS_LINK_TEXT);
        this.addChild(text);

        cleverapps.UI.wrap(this);

        cleverapps.UI.applyHover(this);
        cleverapps.UI.onClick(this, this.onPressed.bind(this));
    },

    onPressed: function () {
        cleverapps.loading.show();

        const loadingHide = cleverapps.waitNoMore(5000, () => cleverapps.loading.hide());

        connector.payments.restoreSubscriptions();
        cleverapps.subscription.on("update", this.createListener(() => {
            loadingHide();

            if (!cleverapps.subscription.isActive()) {
                return;
            }

            this.parentWindow.close();

            cleverapps.focusManager.display({
                focus: "SubscriptionWindow",
                stack: true,
                action: (f) => {
                    new SubscriptionWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }), this);
    }
});